import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/runner/work/whoplays-web/whoplays-web/node_modules/next/dist/client/app-dir/link.js");
